import { FormControl } from "native-base";

export default FormControl;